import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmsAppColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 8.85714C2 6.45692 2 5.25681 2.46711 4.34004C2.878 3.53363 3.53363 2.878 4.34004 2.46711C5.25681 2 6.45692 2 8.85714 2H15.1429C17.5431 2 18.7432 2 19.6599 2.46711C20.4664 2.878 21.122 3.53363 21.5329 4.34004C22 5.25681 22 6.45692 22 8.85714V15.1429C22 17.5431 22 18.7432 21.5329 19.6599C21.122 20.4664 20.4664 21.122 19.6599 21.5329C18.7432 22 17.5431 22 15.1429 22H8.85714C6.45692 22 5.25681 22 4.34004 21.5329C3.53363 21.122 2.878 20.4664 2.46711 19.6599C2 18.7432 2 17.5431 2 15.1429V8.85714Z",
			fill: "url(#bw-sms-app-gradient)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0001 16.9999C15.5505 16.9999 18.4287 14.6014 18.4287 11.6428C18.4287 8.68414 15.5505 6.28564 12.0001 6.28564C8.44968 6.28564 5.57153 8.68414 5.57153 11.6428C5.57153 13.5181 6.72788 15.1684 8.47882 16.1255C8.42018 16.6019 8.24403 17.2376 7.71439 17.7142C8.71589 17.5339 9.51518 17.1717 10.1123 16.7652C10.7092 16.9178 11.3432 16.9999 12.0001 16.9999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "bw-sms-app-gradient",
			x1: 12,
			y1: 2,
			x2: 12,
			y2: 22,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5AF575" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#13BD2C"
			})]
		}) })
	]
});
export default SvgSmsAppColor;
